var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}


function gtag_report_conversion(url) {
  var callback = function () {
//     if (typeof(url) != 'undefined') {
//       window.location = url;
//     }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-580632567/jwcNCLDF4t8BEPf_7pQC',
      'value': 1.0,
      'currency': 'GBP',
      'event_callback': callback
  });
  return false;
}




$( 'a[href*="#"]' ).click( function( e ) {
  var $this = $( this ),
      thisHash = $this.prop( 'hash' ),
      $thisHash = $( thisHash );

  if ( thisHash != '#' && thisHash != '' ){

    // If anchor is on the same page animate / scroll to it
    if ( $thisHash.length ) {
      e.preventDefault();

      if( $thisHash.offset().top > 0 ) {
        $( 'html, body' ).animate( { scrollTop: $thisHash.offset().top - ( $( '#shopify-section-header' ).height() * 1.25) }, 1000);
      }
    }
  }
} );


function addToCartFail() {

  alert("Cart Error: One of the product(s) quantity is unavailable to add to cart.");

}

function samesize(){	
  if ($(window).width() >= 767) {
  // Select and loop the container element of the elements you want to equalise
  $('.regimen-product').each(function(){    
    $('.product-desc',this).css("height", "auto");    
    // Cache the highest
    var highestBox = 0;     
    // Select and loop the elements you want to equalise
    $('.product-desc', this).each(function(){        
      // If this box is higher than the cached highest then store it
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }      
    });             
    // Set the height of all those children to whichever was highest 
    $('.product-desc',this).height(highestBox);                   
  }); 
  
  }
  
}


function selectCheckbox() {
  setTimeout(function(){
    $('.stockist-search-filter-checkbox input').click(function(){
    	if($(this).is(":checked")) {
        	$(this).parents('.stockist-search-filter-checkbox').addClass('checked');
    	} else {
        	$(this).parents('.stockist-search-filter-checkbox').removeClass('checked');
    	}
	});
  },500);
}

function headerTop() {

  setTimeout(function(){
  
    var topHeight = $('.shopify-section').innerHeight();
    
    var blackTopHeight = $('.shopify-section').innerHeight();
    
    $('.main-content').css({'padding-top' : '' + topHeight + 'px'});
    $('.mobile-nav-wrapper').css({'top' : '' + blackTopHeight + 'px'});
    $('.mobile-nav-wrapper').css({'padding-bottom' : '' + blackTopHeight + 'px'});
  
  }, 2000);

}


function equalHeight() {
  

  
  
 $.fn.equalHeight = function(){

   
	var max_height = 0;
	$(this).each(function(){

		max_height = Math.max($(this).height(), max_height);
	});
	$(this).each(function(){
		$(this).height(max_height);
	});
};
  
  /*
 $.fn.extend({
  equalHeight: function() {
   var top = 0;
   var row = [];
   var classname = ('equalHeight' + Math.random()).replace('.', '');
   $(this).each(function() {
    var thistop = $(this).offset().top;
    if (thistop > top) {
     $('.' + classname).removeClass(classname);
     top = thistop;
    }
    $(this).addClass(classname);
    $(this).height('auto');
    var h = (Math.max.apply(null, $('.' + classname).map(function() {
     return $(this).outerHeight();
    }).get()));
     
     
    $('.' + classname).height(h);
   }).removeClass(classname);

  }
 });
  */
  
   $('.search-product-list .product-item .list-view-item__title-column').equalHeight();
  //$('.inner-product-wrapper .slick-list').equalHeight();
  
  
   if($(window).width() > 575){

		 $('.inner-product-wrapper .inner-product-block .inner-product-title').equalHeight(); 
     	 $('.inner-product-wrapper .inner-product-block .price').equalHeight(); 
     
     
 		
   }
  
  $('.module-slider .module-product-detail .module-product-title').equalHeight();
  $('.skincare-solution-wrapper .product-desc h3').equalHeight();
  $('div.snize-ac-results span.snize-title').equalHeight();
  
  
//   $('.thumb-slider .owl-item .item').equalHeight();
//   setTimeout(function(){    
//   	$('.homeslider .slide-wrapper .slider-img').equalHeight();   
//    },500)
}


jQuery(document).ready(function($) { 
  
  /*modal 31-08-2020*/
  
  var $modalOverlay = $('.overlay'); // Cache your selectors
			var $modal        = $('.custom-modal');
			var $modalClose   = $('.modalClose');
			var $modalOpen    = $('.modalOpen');
  			var $modal_inner  = $('.modal-inner');
			var $modal_length = $('.overlay').length;
  		if($modal_length > 0){
          //console.log('hi');
          
          
			$modalOpen.on('click touchstart', function(){
             
              
                            BV.pixel.trackConversion({
  "type" : "BuyNow"
//   "label" : "value",
//   "value" : "value"
});
              
              
  				$modalOverlay.stop().fadeTo(500,1);
              	$("body,html").addClass("open");
			});

			$modalOverlay.on('click touchstart', function(){
  				$modalOverlay.stop().fadeTo(500,0, function(){ $(this).hide(); });
			});

			$modal_inner.on('click touchstart', function(e){
   				e.stopPropagation(); // otherwise the click would bubble up to the overlay
			});

			$modalClose.on('click touchstart', function(){
  				 // simulate click to close modal
              	$("body,html").removeClass("open");
			});
  			$modal.on('click touchstart', function(){
  				$("body,html").removeClass("open");
  			});
  			$modalClose.on('click touchstart', function(){
              $modalOverlay.fadeOut();
  			});
  }
  
  
  
  
  // contact-form-listing
  $('.contact-listing li a').on('click',function(){
    var _this = $(this).attr("data-id");
    var _currentForm = $(this).closest(".contact-form-page").find("[id='" + _this + "']");
    $(this).closest('li').siblings().find('a').removeClass('active');
    $(this).addClass('active');
    $(this).closest(".contact-form-page").find('.form-block-inner').removeClass('active');
    _currentForm.addClass('active');
    $('body,html').animate({
      scrollTop:$('.form-block').position().top - $('header').height()
    },1000);
    $('.thankyou-block').removeClass('active');
  });


  
  
  
  
  
  selectCheckbox();
  
  headerTop();
  
  setTimeout(function(){
  
    equalHeight();
    
  },200);
   
  
  $('body :not(script)').contents().filter(function() {
    return this.nodeType === 3;
}).replaceWith(function() {
    return this.nodeValue.replace(/[®]/g, '<sup>$&</sup>');
});
  

  
  if($('.store-locator')){
    $('.store-locator a').on('click', function(){
      
      // .store-locator #stockist-widget .stockist-search-filter-checkbox label 
      

      
      $('.store-locator #stockist-widget .stockist-search-filter-checkbox input').eq(($(this).data('id')-1)).click() 
      
    });
    
   
    
  }
  
  
  theme.MobileNav = (function() {
    var classes = {
      mobileNavOpenIcon: 'mobile-nav--open',
      mobileNavCloseIcon: 'mobile-nav--close',
      navLinkWrapper: 'mobile-nav__item',
      navLink: 'mobile-nav__link',
      subNavLink: 'mobile-nav__sublist-link',
      return: 'mobile-nav__return-btn',
      subNavActive: 'is-active',
      subNavClosing: 'is-closing',
      navOpen: 'js-menu--is-open',
      subNavShowing: 'sub-nav--is-open',
      thirdNavShowing: 'third-nav--is-open',
      subNavToggleBtn: 'js-toggle-submenu'
    };
    var cache = {};
    var isTransitioning;
    var $activeSubNav;
    var $activeTrigger;
    var menuLevel = 1;
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    var mediaQuerySmall = 'screen  and (min-width: 750px) and (max-width: 1024px)';
    function init() {
      cacheSelectors();
      cache.$mobileNavToggle.on('click', toggleMobileNav);
      // cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);
      // Close mobile nav when unmatching mobile breakpoint
      enquire.register(mediaQuerySmall, {
        unmatch: function() {
          if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
            closeMobileNav();
          }
        }
      });
    }
    function toggleMobileNav() {
      if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
        closeMobileNav();
        $('body,html').removeClass('open-menu');
      } else {
        openMobileNav();
        $('body,html').addClass('open-menu');
      }
    }
    function cacheSelectors() {
      cache = {
        $pageContainer: $('#PageContainer'),
        $siteHeader: $('.site-header'),
        $mobileNavToggle: $('.js-mobile-nav-toggle'),
        $mobileNavContainer: $('.mobile-nav-wrapper'),
        $mobileNav: $('#MobileNav'),
        $sectionHeader: $('#shopify-section-header'),
        $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
      };
    }
    function openMobileNav() {
      var translateHeaderHeight = cache.$siteHeader.outerHeight();
      cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
      cache.$mobileNavContainer.css({
        //transform: 'translateY(' + translateHeaderHeight + 'px)'
      });
      cache.$pageContainer.css({
        transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
      });
      slate.a11y.trapFocus({
        $container: cache.$sectionHeader,
        $elementToFocus: cache.$mobileNavToggle,
        namespace: 'navFocus'
      });
      cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);
      // close on escape
      $(window).on('keyup.mobileNav', function(evt) {
        if (evt.which === 27) {
          closeMobileNav();
        }
      });
    }
    function closeMobileNav() {
      cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
      cache.$mobileNavContainer.css({
        transform: 'translateY(-100%)'
      });
      cache.$pageContainer.removeAttr('style');
      slate.a11y.trapFocus({
        $container: $('html'),
        $elementToFocus: $('body')
      });
      cache.$mobileNavContainer.one(
        'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
        function() {
          slate.a11y.removeTrapFocus({
            $container: cache.$mobileNav,
            namespace: 'navFocus'
          });
        }
      );
      cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();
      $(window).off('keyup.mobileNav');
      scrollTo(0, 0);
    }
    function toggleSubNav(evt) {
      if (isTransitioning) {
        return;
      }
      var $toggleBtn = $(evt.currentTarget);
      var isReturn = $toggleBtn.hasClass(classes.return);
      isTransitioning = true;
      if (isReturn) {
        // Close all subnavs by removing active class on buttons
        $(
          '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
        ).removeClass(classes.subNavActive);
        if ($activeTrigger && $activeTrigger.length) {
          $activeTrigger.removeClass(classes.subNavActive);
        }
      } else {
        $toggleBtn.addClass(classes.subNavActive);
      }
      $activeTrigger = $toggleBtn;
      goToSubnav($toggleBtn.data('target'));
    }
    function goToSubnav(target) {
      /*eslint-disable shopify/jquery-dollar-sign-reference */
      var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;
      menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;
      if ($activeSubNav && $activeSubNav.length) {
        $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
      }
      $activeSubNav = $targetMenu;
      /*eslint-enable shopify/jquery-dollar-sign-reference */
      var translateMenuHeight = $targetMenu.outerHeight();
      var openNavClass =
          menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
      cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);
      if (!target) {
        // Show top level nav
        cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
      }
      /* if going back to first subnav, focus is on whole header */
      var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;
      var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
      var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;
      // Focusing an item in the subnav early forces element into view and breaks the animation.
      cache.$mobileNavContainer.one(
        'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
        function() {
          slate.a11y.trapFocus({
            $container: $container,
            $elementToFocus: $elementToFocus,
            namespace: 'subNavFocus'
          });
          cache.$mobileNavContainer.off('.subnavToggle');
          isTransitioning = false;
        }
      );
      // Match height of subnav
      cache.$pageContainer.css({
        transform: 'translateY(' + translateMenuHeight + 'px)'
      });
      $activeSubNav.removeClass(classes.subNavClosing);
    }
    return {
      init: init,
      closeMobileNav: closeMobileNav
    };
  })(jQuery);
  samesize();
  
  //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
  
  /*
  if( getCookie('popupCookie') != 'submited'){ 
    if(getCookie('popupCookie') != 'closed' ){ 
      $('#skincare-modal').modal('show');    			 
    }
  }
  $('#closeCookie').click(function(){  
    setCookie( 'popupCookie', 'closed', 7 ); 
  });
  */
  /*
  $( "#buynow" ).click(function() {
	bvCallback();
	});
  window.bvCallback = function (BV) {
		    BV.pixel.trackConversion({
		      "type" : "Where To Buy", 
		      "label" : "LandingPage",
		      "value" : "78702"
		    });
		};
*/  
//   $('.mobile-nav-wrapper .mobile-nav .mobile-nav__item').click(function(){    
//         $('.mobile-nav-wrapper .mobile-nav .mobile-nav__item .mobile-nav__dropdown').slideUp();
//     	$('.mobile-nav-wrapper .mobile-nav .mobile-nav__item').removeClass('open-sub-nav');
// //  		$('body,html').removeClass('open-menu'); 
//     	if ($(this).find('.mobile-nav__dropdown').is(':visible')) {
//     		$(this).find('.mobile-nav__dropdown').slideUp();
//           	$(this).removeClass('open-sub-nav');
// 		}
//     	else{
// 	 		$(this).find('.mobile-nav__dropdown').slideToggle();
//           	$(this).addClass('open-sub-nav');
            
//     	}  
//   });  
  
  
  /* 07-02 */
   jQuery(".mobile-nav li").each(function(){
    if(jQuery(this).has("ul").length){
      jQuery(this).addClass('sub');
    }
  });
  jQuery(".mobile-nav li.sub").append("<span class='sub-span'></span>");
  
jQuery(".mobile-nav__item.sub").click(function(e) {


    if (jQuery(this).children(".mobile-nav__item.sub .mobile-nav__link").hasClass('active-bg')) {     
      jQuery(this).children(".mobile-nav__item.sub .mobile-nav__link").removeClass("active-bg").siblings(".mobile-nav__dropdown").stop(true , false).slideUp();
      jQuery(this).children(".mobile-nav__dropdown").children(".mobile-nav__item.sub").children(".mobile-nav__item.sub .mobile-nav__link").removeClass("active-bg").siblings(".mobile-nav__dropdown").stop(true , false).slideUp();
      jQuery(this).children(".sub-span").removeClass("active");
       jQuery(this).children(".mobile-nav__dropdown").children(".mobile-nav__item.sub").children(".sub-span").removeClass("active");

    } 
    else {
      jQuery(this).children(".mobile-nav__dropdown").children(".mobile-nav__item.sub").children(".sub-span").removeClass("active");
       jQuery(this).siblings().children(".sub-span").removeClass("active");
      jQuery(this).siblings().children(".mobile-nav__item.sub .mobile-nav__link").removeClass("active-bg").siblings(".mobile-nav__dropdown").stop(true , false).slideUp();
      jQuery(this).children(".mobile-nav__dropdown").children(".mobile-nav__item.sub").children(".mobile-nav__item.sub .mobile-nav__link").removeClass("active-bg").siblings(".mobile-nav__dropdown").stop(true , false).slideUp();
      jQuery(this).children(".mobile-nav__item.sub .mobile-nav__link").addClass("active-bg").siblings(".mobile-nav__dropdown").stop(true , false).slideDown();
		jQuery(this).children(".sub-span").addClass("active");
    }
    e.stopPropagation();
  });
  


  
  
  
  $(".humber-menu").click(function(){
//     alert();
  	  	$('body,html').toggleClass('open-menu');
  });
  openmobilemenu();
  
  
    

  
  
});
function openmobilemenu(){

}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


var BrowserDetect = {
  init: function () {
    this.browser = this.searchString(this.dataBrowser) || "Other";
    this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
  },
  searchString: function (data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      this.versionSearchString = data[i].subString;
      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  },
  searchVersion: function (dataString) {
    var index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }
    var rv = dataString.indexOf("rv:");
    if (this.versionSearchString === "Trident" && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    }
  },
  dataBrowser: [
    {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
    {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
    {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
    {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
    {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
    {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  
    {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
    {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
  ]
};


BrowserDetect.init();
var bv= BrowserDetect.browser;
if( bv == "Chrome"){
  $("html").addClass("chrome");
}
else if(bv == "MS Edge"){
  $("html").addClass("edge");
}
else if(bv == "Explorer"){
  $("html").addClass("ie");
}
else if(bv == "Firefox"){
  $("html").addClass("Firefox");
}


/***For browser and os specific class***/
var deviceAgent = navigator.userAgent.toLowerCase();
if (deviceAgent.match(/(iphone|ipod|ipad)/)) {
  $('html').addClass('ios');
  $('html').addClass('mobile');
}
if (deviceAgent.match(/android/)) {
  $('html').addClass('android');
  $('html').addClass('mobile');
}
if (deviceAgent.match(/blackberry/)) {
  $('html').addClass('blackberry');
  $('html').addClass('mobile');
}
if (deviceAgent.match(/(symbianos|^sonyericsson|^nokia|^samsung|^lg)/)) {
  $('html').addClass('mobile');
}


function headerAdj(){
  var header_height = $("header").innerHeight();
  $(".wrapper").css("padding-top", header_height);
}


function sticky_header(){
  $(window).scroll(function(){
    if ($(window).width() >= 767) {
      if ($(window).scrollTop() >= 100) {
        $('header').addClass('sticky-listing-header');
        $('body').addClass('sticky-header');
      }
      else {
        $('header').removeClass('sticky-listing-header');
        $('body').removeClass('sticky-header');
      }
    }
    else{
      $('header').removeClass('sticky-listing-header');
      $('body').removeClass('sticky-header');
    }
  });
}


// function menu_open(){
//   $(".humber-menu").click(function(){
// //     alert("hello");
//     if ($(window).width() <= 1024) {
//       $("body,html").toggleClass("open-menu");
// //       $(".header-navigation").slideToggle();
//       $(document).click(function(e){
//         e.stopPropagation();
//         if ($(e.target).closest('.header-navigation').length === 0 && $(e.target).closest('.humber-menu-inner').length === 0 ) {
//           $("body,html").removeClass("open-menu");
//           $(".header-navigation").slideUp();
//         }
//       });
//     }
//   });
// }


function desktopClass(){
  if ($(window).width() > 1024) {
    $('.header-navigation-wrapper').addClass("desk").removeClass('mob');
    $('.roc-megamenu-wrapper').bind('hover');
  } else {
    $('.header-navigation-wrapper').removeClass("desk").addClass('mob');
    $('.roc-megamenu-wrapper').bind('click');
  }
}




$slick_product_slider = false;
function innerproduct_slider() {
  if ($(window).width() < 768) {
    if (!$slick_product_slider) {
      $(".product-detail-page-slider.deep-wrinkle .inner-product-wrapper").not('.slick-initialized').slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        autoplay: false,
        autoplaySpeed: 7000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: true
      });
      $slick_product_slider = true;
    }
  } else if ($(window).width() > 768) {
    if ($slick_product_slider) {
      $(".product-detail-page-slider.deep-wrinkle .inner-product-wrapper").slick('unslick');
      $slick_product_slider = false;
    }
  }
}


$(document).ready(function(){
  headerAdj();
//   menu_open();
  sticky_header();
  desktopClass();
  
//   $('.roc-home-slider').height($(window).height());
  
  
  
  $('.roc-megamenu-wrapper').hover(function() {
    if($('.header-navigation-wrapper').hasClass('desk')){
      var submenu = $(this).children('.roc-megamenu');
      if ($(submenu).is(':visible') ) {
        $(submenu).hide();
      } else {
        $(submenu).show();
      }   
    }
  });
  $('.header-navigation-wrapper.mob .roc-megamenu-wrapper').click(function() {
    if($('.header-navigation-wrapper').hasClass('mob')){
      var submenu = $(this).children('.roc-megamenu');
      if ($(submenu).is(':visible') ) {
        $(submenu).slideUp(400);
        $(this).removeClass("open-submenu");
      } else {
        $('.roc-megamenu').slideUp(400);
        $(submenu).slideDown(400);
        $(this).addClass("open-submenu");
      }
    }
  });
  
//   $(".homeslider").slick({
    
//     dots: true,
//     arrows: false,
//     infinite: false,
//     speed: 1000,    
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     draggable: true,
//     autoplay: true,
//     autoplaySpeed: 7000,
//     pauseOnHover: true,
//     pauseOnFocus: true,
//   });
  

  innerproduct_slider();
  
  
//     $('.homeslider').on('setPosition', function () {
	  
	
//       $(this).find('.slick-slide').height('auto');
//       var slickTrack = $(this).find('.slick-track');
//       var slickTrackHeight = $(slickTrack).height();
//       $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
      
      
//       $(this).find('.slick-track .slider-img').height('auto');
//       var slickTrackImg = $(this).find('.slick-track .slider-img');
      

//       var slickTrackImgHeight = $(slickTrackImg).height();
      
     
//       $(this).find('.slick-track .slider-img').css('height', slickTrackImgHeight + 'px');
      
    
//       });
  
  
  
  
  
  /**Product detail js**/
  
//   synchronized slider
  
var sync1 = $("#sync1");
	var sync2 = $("#sync2");
	var slidesPerPage = 5; //globaly define number of elements per page
	var syncedSecondary = true;

	sync1.owlCarousel({
		items: 1,
		slideSpeed: 2000,
		nav: false,
		autoplay: false,
		dots: false,
		loop: false,
      		mouseDrag: false,
		touchDrag: false,
		responsiveRefreshRate: 200,
		navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
	}).on('changed.owl.carousel', syncPosition);

	sync2
	.on('initialized.owl.carousel', function () {
		sync2.find(".owl-item").eq(0).addClass("current");
	})
	.owlCarousel({
		items: slidesPerPage,
		dots: false,
		nav: true,
      touchDrag  : true,
    	 mouseDrag  : true,
      	margin:10,
		smartSpeed: 200,
		slideSpeed: 500,
		mouseDrag: true,
		touchDrag: true,
      navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
		slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
		responsiveRefreshRate: 100
		});//.on('changed.owl.carousel', syncPosition2);

	function syncPosition(el) {
      
      
      
      sync2.data('owl.carousel').to(el.item.index, 100, true);
      
      sync2
		.find(".owl-item")
		.removeClass("current")
		.eq(el.item.index)
		.addClass("current");
      
      /*

		var count = el.item.count - 1;
		var current = Math.round(el.item.index - (el.item.count / 2) - .5);
      

      
      

		if (current < 0) {
			current = count;
		}
		if (current > count) {
			current = 0;
		}

      

      

		sync2
		.find(".owl-item")
		.removeClass("current")
		.eq(current)
		.addClass("current");
		var onscreen = sync2.find('.owl-item.active').length - 1;
		var start = sync2.find('.owl-item.active').first().index();
		var end = sync2.find('.owl-item.active').last().index();

      

      
		if (current > end) {
			sync2.data('owl.carousel').to(current, 100, true);
		}
		if (current < start) {
			sync2.data('owl.carousel').to(current - onscreen, 100, true);
		}
        
        */
	}

	function syncPosition2(el) {
		if (syncedSecondary) {
			var number = el.item.index;
			sync1.data('owl.carousel').to(number, 100, true);
		}
	}

	sync2.on("click", ".owl-item", function (e) {      
		e.preventDefault();
		var number = $(this).index();
		sync1.data('owl.carousel').to(number, 300, true);
	});

  
   if($(window).width() > 768){
     
  $('#sync1 .product-img').zoom({
    magnify: 0.8
  });
     
   }
  

  
  
if($("#sync1").length){
  
   $("#sync1").swipe( { fingers:'all', swipeLeft:swipe1, swipeRight:swipe1, allowPageScroll:"auto"} );
  
}

  function swipe1(event, direction, distance, duration, fingerCount) {
       // alert( "You have swiped " + direction +' with ' + fingerCount +' fingers' );
    if(direction == 'left'){
      $("#sync1").trigger('next.owl.carousel');
    }else if(direction == 'right'){
      $("#sync1").trigger('prev.owl.carousel');
    }
      }
  
  
 
//   $('.product-slider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     asNavFor: '.thumb-slider',
//     speed: 500
// });
//   $('.thumb-slider').on('init', function(event, slick) {
//  		$('.thumb-slider .slick-slide.slick-current').addClass('is-active');
//  	})
//   .slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     asNavFor: '.product-slider',
//     focusOnSelect: true,
//     prevArrow: false,
//     nextArrow: false,
//     infinite: false,
//     draggable: false,
//     responsive: [{
//         breakpoint: 1200,
//         settings: {
//             slidesToShow: 5
//         }
//     },
//     {
//         breakpoint: 992,
//         settings: {
//             slidesToShow: 5
//         }
//     },
//     {
//         breakpoint: 768,
//         settings: {
//             slidesToShow: 5
//         }
//     },
//     {
//         breakpoint: 480,
//         settings: {
//             slidesToShow: 5
//         }
//     }
//     ]
// });
  
  
  
  
//    $('.product-slider').on('afterChange', function(event, slick, currentSlide) {
//  	$('.thumb-slider').slick('slickGoTo', currentSlide);
//  	var currrentNavSlideElem = '.thumb-slider .slick-slide[data-slick-index="' + currentSlide + '"]';
//  	$('.thumb-slider .slick-slide.is-active').removeClass('is-active');
//  	$(currrentNavSlideElem).addClass('is-active');
//  });

//  $('.thumb-slider').on('click', '.slick-slide', function(event) {
//  	event.preventDefault();
//  	var goToSingleSlide = $(this).data('slick-index');

//  	$('.product-slider').slick('slickGoTo', goToSingleSlide);
//  });

// //   =====================================
  
//    $('.product-slider').slick({
//  	slidesToShow: 1,
//  	slidesToScroll: 1,
//  	arrows: true,
//  	fade: false,
//  	adaptiveHeight: true,
//  	infinite: false,
// 	useTransform: true,
//  	speed: 400,
//  	cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
//  });

//  $('.thumb-slider')
//  	.on('init', function(event, slick) {
//  		$('.thumb-slider .slick-slide.slick-current').addClass('is-active');
//  	})
//  	.slick({
//  		slidesToShow: 7,
//  		slidesToScroll: 7,
//  		dots: false,
//  		focusOnSelect: false,
//  		infinite: false,
//  		responsive: [{
//  			breakpoint: 1024,
//  			settings: {
//  				slidesToShow: 5,
//  				slidesToScroll: 5,
//  			}
//  		}, {
//  			breakpoint: 640,
//  			settings: {
//  				slidesToShow: 4,
//  				slidesToScroll: 4,
// 			}
//  		}, {
//  			breakpoint: 420,
//  			settings: {
//  				slidesToShow: 3,
//  				slidesToScroll: 3,
// 		}
//  		}]
//  	});

//  $('.product-slider').on('afterChange', function(event, slick, currentSlide) {
//  	$('.thumb-slider').slick('slickGoTo', currentSlide);
//  	var currrentNavSlideElem = '.thumb-slider .slick-slide[data-slick-index="' + currentSlide + '"]';
//  	$('.thumb-slider .slick-slide.is-active').removeClass('is-active');
//  	$(currrentNavSlideElem).addClass('is-active');
//  });

//  $('.thumb-slider').on('click', '.slick-slide', function(event) {
//  	event.preventDefault();
//  	var goToSingleSlide = $(this).data('slick-index');

//  	$('.product-slider').slick('slickGoTo', goToSingleSlide);
//  });
  
  
// //   =======================================
  
  $('.all-ingredients  span').click(function(e) {
    e.preventDefault();
    $(this).closest('.all-ingredients').toggleClass('active');
    $(this).closest('.key-ingredients').toggleClass('active');
    $('.all-ingredients-texts').slideToggle('slow');
  });
  $('.quote-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    prevArrow: false,
    nextArrow: false,
    speed: 1000,
    responsive: [{
      breakpoint: 768,
      settings: {
        dots: true,
      }
    }]
  });
  
  //Quiz page JS
  customDropdown();
  
  
  $(".quize-section .roc-btn-black").on("click", function(){
    
    
    $('.inner-product-wrapper .inner-product-block .inner-product-title').css({  height: 'auto' });
    
    
     equalHeight();
    

    
    
    var product_offset = $(".customer-fav-product").offset().top - $("#shopify-section-header").innerHeight();
    $("body, html").stop().animate({scrollTop:product_offset}, 500);
  });
  
});


/*
function signUpForm(){
  if(emailIsValid($('#email-address').val()) ){
    $.ajax({
      url: '/contact',
      dataType: 'text',
      type: 'post',
      contentType: 'application/x-www-form-urlencoded',
      data: 'email=' +  $('#email-address').val(),
      success: function( data, textStatus, jQxhr ){
        fadeSuccess('thanks for subscribing');
      },
      error: function( jqXhr, textStatus, errorThrown ){
        fadeError('there was an issue subscribing,  please try again later');
      }
    });
  }else{
    fadeError('invalid email address');
  }
}


function signUpForm2(){
  if(emailIsValid($('#email-address-pop').val()) ){
    $.ajax({
      url: '/contact',
      dataType: 'text',
      type: 'post',
      contentType: 'application/x-www-form-urlencoded',
      data: 'email=' +  $('#email-address-pop').val(),
      success: function( data, textStatus, jQxhr ){
        $('#skincare-modal').modal('hide');
        $('#skincare-modal2').modal('show');
        setCookie( 'popupCookie', 'submited', 14 );
      },
      error: function( jqXhr, textStatus, errorThrown ){
        fadeError2('there was an issue subscribing,  please try again later');
      }
    });
  }else{
    fadeError2('invalid email address');
  }
}
*/

function fadeError2(message ){
  $('#error-signup-pop').html(message);
  $('#error-signup-pop').hide();
  $('#error-signup-pop').fadeIn(1000);         
}


function fadeError(message ){
  $('#success-signup').html('');
  $('#error-signup').html(message);
  $('#error-signup').hide();
  $('#error-signup').fadeIn(1000);
}


function fadeSuccess(message ){
  $('#error-signup').html('');
  $('#success-signup').html(message);
  $('#success-signup').hide();
  $('#success-signup').fadeIn(1000);
}


function emailIsValid (email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function videoPlay() {
  
  	$(".play-video-icon, .play-video-link, .skincare-solution .product-desc .roc-btn").click(function(){
        var data_src = $(this).attr("data-src");
        $('.video-modal .embed-responsive-item').attr('src', data_src);
    });
  
    $(".play-image-icon, .play-image-link").click(function(){
        var data_src = $(this).attr("data-src");
        $('.image-modal .embed-responsive-item').attr('src', data_src);
    });

    $(".btn-close").click(function(){
        $('.video-modal .embed-responsive-item').attr('src', '');
      	$('.image-modal .embed-responsive-item').attr('src', '');
    });
}

function slider_section() {
  
  $('.module-slider-wrapper').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
           
            
          }
        },
        { breakpoint: 900,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }]
    });
  
	/* module-2 slider */ 
  
  
  	/* customer fav prodcut slider 13-03 */
  
   $('.home-customer-fav .inner-product-wrapper').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
        { breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
           breakpoint: 576,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
           }
        }]
    });
  
  /* customer fav prodcut slider 13-03 */

  /* module-3 slider */
  
  
  
   // Set preferred slidesToShow
    var slidesToShow = 3;
   var slidesToShowTablet = 2;
    var childElements = $('.skincare-solution-wrapper').children().length;

    if( slidesToShow > (childElements) ) {
        slidesToShow = (childElements);
    }
  
  if( slidesToShowTablet > (childElements) ) {
        slidesToShowTablet = (childElements);
    }
  

  
  
 	$('.skincare-solution-wrapper').not('.slick-initialized').slick({
        dots: false,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: slidesToShowTablet,
            slidesToScroll: 1,
            dots: true
          }
        },
        { breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }]
    });

  	/* module-3 slider */
  
  
  	$('.roc-home-slider .home-banner-slider').not('.slick-initialized').slick({
  
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        { breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        },
        {
           breakpoint: 576,
           settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
           }
        }]
   
	});
}


$(window).resize(function(){
  headerTop();
  headerAdj();
  sticky_header();
  innerproduct_slider();
  desktopClass();
  slider_section();
  setTimeout(function(){
  
    equalHeight();
    
  },1000);
  
  samesize();
  videoPlay();
  
    $('.homeslider').slick('reinit');
  	$('.homeslider').slick('slickNext');
  
  
});



$(document).ready(function(){
 
  videoPlay(); 
  
  slider_section();
  
    /* PDP Video */
  
  	$(".play-video-icon, .skincare-solution .product-desc .roc-btn").click(function(){
        var data_src = $(this).attr("data-src");
        $('.video-modal .embed-responsive-item').attr('src', data_src);
    });

    $(".btn-close").click(function(){
        $('.video-modal .embed-responsive-item').attr('src', '');
    });
  
  
  
/* FAQ */

  $('.faq-list .title').click(function(){
    $('.faq-list li').not($(this).parent('.faq-list li')).removeClass();
    $('.faq-detail').not($(this).parent('.faq-list li').find('.faq-detail')).slideUp();
    $(this).parent('.faq-list li').find('.faq-detail').slideToggle();
    $(this).parent('.faq-list li').toggleClass('active');

  });
  
/* FAQ */
  
  $(".search-icon .site-nav__label").click(function(){

    $(this).parents(".search-icon").find(".search-detail").toggle();
    $('.search-input').focus();

  });
  
  $(".search-icon-mobile .search-icon .site-nav__label").click(function(){

    $(this).parents(".search-icon-mobile").find(".search-detail").toggle();

  });
  
   
  $(".search-detail .close-icon, div.snize-ac-results li.snize-view-all-link").click(function(){

    $(".search-detail").css({"display":"none"});

  });
  
/* Special offer */
  
  $(".offer-row .more-btn").click(function(){

		$(this).parents(".offer-row-wrapper").toggleClass("active");
		$(this).toggleClass("open");
		$(this).parent(".offer-row").siblings(".more-detail-content").slideToggle();

	});

/* Special offer */  
  
});

$(window).load(function(){

  selectCheckbox();
  
  
});




function customDropdown(){

  
    if($(window).width() > 767){
      $(".quize-section .custom-dropdown").each(function() {
        $(this).select2({
          minimumResultsForSearch: Infinity,
          dropdownParent: $(this).closest('.custom-dropdown-wrap'),
          placeholder: {
              id: '1',
              text: 'Select'
            },
        }).on("select2:select", function () {
          
          
          //hide options
          if($(".quize-section #face_condition").val() == 'no_signs_of_aging'){
            
      
            
            if(	$(".quize-section #biggest_skin_concern").val() == "deep_wrinkles" || $(".quize-section #biggest_skin_concern").val() == "loose_sagging_skin" || $(".quize-section #biggest_skin_concern").val() == "dark_spots_discoloration"){
           	
              $(".quize-section #biggest_skin_concern").val(1).trigger('change');
            }
            
            
          	$(".quize-section #biggest_skin_concern option[value*='deep_wrinkles']").prop('disabled',true);
            $(".quize-section #biggest_skin_concern option[value*='loose_sagging_skin']").prop('disabled',true);
           	$(".quize-section #biggest_skin_concern option[value*='dark_spots_discoloration']").prop('disabled',true);
            
            
          
           }else if($(".quize-section #face_condition").val() != 'no_signs_of_aging'){
          
          	$(".quize-section #biggest_skin_concern option[value*='deep_wrinkles']").prop('disabled',false);
            $(".quize-section #biggest_skin_concern option[value*='loose_sagging_skin']").prop('disabled',false);
          	$(".quize-section #biggest_skin_concern option[value*='dark_spots_discoloration']").prop('disabled',false);
           }
          
          
          
          
          
          
          
          
          
          
          var disable_toggle = $(this).closest("li");
          $(this).closest("li").addClass("active_option");
          if(disable_toggle.next().hasClass("disable-option")){
            disable_toggle.next().removeClass("disable-option");
          }
          if(disable_toggle.is(":last-child")){
            $(".quize-section .roc-btn-black").css({'visibility':'visible', 'opacity':1});
          }
          
          
          
          //change happened
          var changedHappened=0;
           $(".quize-section .custom-dropdown").each(function() {
              var disable_toggle = $(this).closest("li");
             
             if( $(this).val() == '1' || $(this).val() == null || changedHappened == 1){
                disable_toggle.next().addClass("disable-option");
                disable_toggle.next().removeClass("active_option");
               $(".quize-section .roc-btn-black").css({'visibility':'hidden', 'opacity':0});
                changedHappened=1;
               $(this).val(1).trigger('change');
             }
             
           });
          
          
          
          
        });
        $(this).val(null).trigger('change');
//         $(this).val('1'); 
//         $(this).trigger('change');
        
        
      });
  	}
  else{
    var $select = $('.custom-dropdown').select2();
	$select.each(function(i,item){
  		$(item).select2("destroy");
	});
  	 $(".custom-dropdown").change(function () {
       
       
                 //hide options
          if($(".quize-section #face_condition").val() == 'no_signs_of_aging'){
            
      
            
            if(	$(".quize-section #biggest_skin_concern").val() == "deep_wrinkles" || $(".quize-section #biggest_skin_concern").val() == "loose_sagging_skin" || $(".quize-section #biggest_skin_concern").val() == "dark_spots_discoloration"){
           		$(".quize-section #biggest_skin_concern").val(1);
              
            }
            
            
          	$(".quize-section #biggest_skin_concern option[value*='deep_wrinkles']").prop('disabled',true);
            $(".quize-section #biggest_skin_concern option[value*='loose_sagging_skin']").prop('disabled',true);
           	$(".quize-section #biggest_skin_concern option[value*='dark_spots_discoloration']").prop('disabled',true);
            
            
          
           }else if($(".quize-section #face_condition").val() != 'no_signs_of_aging'){
          
          	$(".quize-section #biggest_skin_concern option[value*='deep_wrinkles']").prop('disabled',false);
            $(".quize-section #biggest_skin_concern option[value*='loose_sagging_skin']").prop('disabled',false);
          	$(".quize-section #biggest_skin_concern option[value*='dark_spots_discoloration']").prop('disabled',false);
           }
       
       
       
       
       
       
        var disable_toggle = $(this).closest("li");
      $(this).closest("li").addClass("active_option");
      if(disable_toggle.next().hasClass("disable-option")){
        disable_toggle.next().removeClass("disable-option");
      }
      if(disable_toggle.is(":last-child")){
        $(".quize-section .roc-btn-black").css({'visibility':'visible', 'opacity':1});
      }
       
       
          //change happened
          var changedHappened=0;
           $(".quize-section .custom-dropdown").each(function() {
              var disable_toggle = $(this).closest("li");
             
             if( $(this).val() == '1' || $(this).val() == null || changedHappened == 1){
                disable_toggle.next().addClass("disable-option");
               disable_toggle.next().removeClass("active_option");
               $(".quize-section .roc-btn-black").css({'visibility':'hidden', 'opacity':0});
               changedHappened=1;
               $(this).val(1);
             }
             
           });
          
       
       
       
       
       
    });
  }

}


function inputNumber(e){

	var el = e;
	el.each(function(){
		el = $(this);

		var min = el.attr('min') || false;
		var max = el.attr('max') || false;

		var els = {};

		els.dec = el.parents(".counter-product-wrapper").find(".input-number-decrement");
		els.inc = el.parents(".counter-product-wrapper").find(".input-number-increment");

		el.each(function() {
			init($(this));
		});

		function init(el) {

			els.dec.on('click', decrement);
			els.inc.on('click', increment);

			function decrement() {
				var value = el[0].value;
				value--;
				if (!min || value >= min) {
					el[0].value = value;
				}
			}

			function increment() {
				var value = el[0].value;
				value++;
				if (!max || value <= max) {
					el[0].value = value++;
				}
			}
		}
	})
} 

inputNumber($('.input-number'));